export default "__VITE_ASSET__A1it67KC__"